import React from "react";
import Logo from "../../../assets/images/logo-black.svg";
import { useSelector } from "react-redux";
import "../CustomerRefundPrint.css";
import moment from "moment";
import { Button } from "antd";
import numeral from "numeral";

const CustomerRefundPrintHeader = () => {
  const { customerRefundPrint } = useSelector((state) => state);
  const headerData = customerRefundPrint && customerRefundPrint?.payload?.data[0];

  const printHandler = () => {
    window.print();
  }

  return (
    <div className="__header">
      <table width="100%">
        <tbody>
          <tr>
            <td width="65%" style={{ paddingRight: "5px" }}>
              <table width="100%">
                <tbody>
                  <tr>
                    <td width="50%">
                      <table width="100%">
                        <tbody>
                          <tr>
                            <td>
                              <div className="__image_container">
                                <img width={250} height={72} src={Logo} alt="Brand Logo" />
                              </div>
                            </td>
                            <td valign="top" width="100%">
                              <div className="__addr">
                                <p>Warp Weft World Inc.</p>
                                <p>121 Varick Street,4th Floor</p>
                                <p>NEW YORK ,NY 10013, USA</p>
                                <p>TEL : (646) 514-9736</p>
                                <p>FAX : (212) 991-9989</p>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                    <td width="50%">
                      <p className="__addr_table_heading">
                        Customer Refund Report
                      </p>
                    </td>
                  </tr>

                  <tr>
                    <td width="50%" valign="top" style={{ paddingRight: "5px" }}>
                      <table width="100%" className="__addr_table">
                        <tbody>
                          <tr>
                            <td valign="top">Transaction # :</td>
                            <td colSpan={3}>{headerData?.refund_header_no || ''}</td>
                          </tr>
                          <tr>
                            <td valign="top">Posting Period :</td>
                            <td colSpan={3}>{headerData?.period_name || ''}</td>
                          </tr>
                          <tr>
                            <td valign="top">Customer :</td>
                            <td colSpan={3}>{headerData?.customer_name || ''}</td>
                          </tr>
                          <tr>
                            <td valign="top">Debit Account :</td>
                            <td colSpan={3}>{headerData?.account_name || ''}</td>
                          </tr>

                        </tbody>
                      </table>
                    </td>
                    <td width="50%" style={{ paddingLeft: "5px" }}>
                      <table width="100%" className="__addr_table">
                        <tbody>
                          <tr>
                            <td valign="top">Date :</td>
                            <td colSpan={5}>{moment(headerData?.refund_date).format("MM-DD-YYYY") || ''}</td>
                          </tr>
                          <tr>
                            <td valign="top">Memo :</td>
                            <td colSpan={5}>
                              {headerData?.memo || ''}
                            </td>
                          </tr>
                          <tr>
                            <td valign="top">A/R Account :</td>
                            <td colSpan={5}>{headerData?.ar_account_name || ''}</td>
                          </tr>
                          <tr>
                            <td valign="top">Remarks :</td>
                            <td colSpan={5}>{headerData?.remarks || ''}</td>
                          </tr>

                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>

            {/* <td valign="top" width="35%" style={{ paddingLeft: "5px" }}>
              <table width="100%" className="__box">
                <tbody>
                  <tr>
                    <td colSpan={2} className="__heading" align="center">Sales Order
                    </td>
                  </tr>
                  <tr>
                    <td width="40%" valign="top">Sales Order :</td>
                    <td>
                      {headerData && headerData.sale_order_no}
                    </td>
                  </tr>
                  <tr>
                    <td valign="top">Order Date :</td>
                    <td>
                      {headerData && moment(headerData.order_date).format("MM-DD-YYYY")}
                    </td>
                  </tr>
                  <tr>
                    <td valign="top">P.O # :</td>
                    <td>
                      {headerData?.po_number}
                    </td>
                  </tr>
                  <tr>
                    <td valign="top">Term :</td>
                    <td>
                      {headerData?.term}
                    </td>
                  </tr>
                  <tr>
                    <td valign="top">Ship Method :</td>
                    <td>
                      {headerData?.ship_via}
                    </td>
                  </tr>
                  <tr>
                    <td valign="top">Freight Terms :</td>
                    <td>
                      {headerData?.frieght_terms}
                    </td>
                  </tr>
                  <tr>
                    <td valign="top">Ship Date(From) :</td>
                    <td>
                      {headerData && moment(headerData.ship_date_from).format("MM-DD-YYYY")}
                    </td>
                  </tr>
                  <tr>
                    <td valign="top">Ship Date(To) :</td>
                    <td>
                      {headerData && moment(headerData.cancel_date).format("MM-DD-YYYY")}
                    </td>
                  </tr>
                  <tr>
                    <td valign="top">Cancel Date :</td>
                    <td>
                      {headerData && moment(headerData.cancel_date).format("MM-DD-YYYY")}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td> */}
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default CustomerRefundPrintHeader;
